import { struct } from '@solana/buffer-layout';
import { publicKey } from '@solana/buffer-layout-utils';
import { PublicKey } from '@solana/web3.js';
import { ExtensionType, getExtensionData } from '../extensionType.js';
/** Buffer layout for de/serializing a permissioned burn config */
export const PermissionedBurnLayout = struct([publicKey('authority')]);
export const PERMISSIONED_BURN_SIZE = PermissionedBurnLayout.span;
export function getPermissionedBurn(mint) {
    const extensionData = getExtensionData(ExtensionType.PermissionedBurn, mint.tlvData);
    if (extensionData !== null) {
        const { authority } = PermissionedBurnLayout.decode(extensionData);
        return {
            authority: authority.equals(PublicKey.default) ? null : authority,
        };
    }
    else {
        return null;
    }
}
//# sourceMappingURL=state.js.map